
/* *****************************    Enums    ***************************** */

export enum NetworkScope {
    RaListExpired = 'SCOPE_RA_LIST_EXPIRED',
    RaList = 'SCOPE_RA_LIST',
    RaDetail = 'SCOPE_RA_INFO',
    RaInsert = 'SCOPE_RA_INSERT',
    CheckOut = 'SCOPE_RA_INSERT_CHECK_OUT',
    CheckIn = 'SCOPE_RA_INSERT_CHECK_IN',
    RaHQ = "SCOPE_CHOOSE_COMPANY_BILLINGOWNER",
    MsApplicationMngList = 'SCOPE_APPLICATION_MNG_LIST',
    MsList = 'SCOPE_MS_LIST',
    MsMng = 'SCOPE_MS_MNG',
    MsDetail = 'SCOPE_MS_DETAIL',
    MsEnableRecovery = 'SCOPE_ENABLE_RECOVERY',
    MsRoyaltiesMngList = 'SCOPE_ROYALTIES_LIST',
    MsRepairShopList = 'SCOPE_REPAIRSHOP_LIST',
    MsContractorMngList = 'SCOPE_CONTRACTOR_LIST',
    RaRetroDatableCheckIn = 'SCOPE_RA_RETRO_DATABLE_CHECK_IN',
    RaKeyBoxCheckIn = 'SCOPE_RA_KEY_BOX_CHECK_IN',
	ParkingTool = 'SCOPE_PARKING_TOOL',
    BookingInsert = 'SCOPE_BOOKING_INSERT',
    RaInsertRecovery = 'SCOPE_RA_INSERT_RECOVERY',
    ManageRaNote = 'SCOPE_MANAGE_RA_NOTE'
}

export interface CustomerSearchFilters {
    cbCustomerId?: string | null,
    bpCode?: string | null,
    taxCode?: string | null,
    vatNumber?: string | null,
    drvLicenceNumber?: string | null,
    lastName?: string | null,
    firstName?: string | null,
    email?: string | null,
    customerType?: string | null,
    role?: any[] | null,
    vip?: string | null,
    partnerType?: string | null,
    businessName?: string | null
}

export interface IEnableRecoveryFilters {
    tenants: string[]
}

export enum checkInOutScenario {
    CheckIn = 'checkin',
    CheckOut = 'chekout',
    SubstitutionCheckIn = 'subIn',
}